import { Button, Stack, Typography } from "@mui/material";
import { useTriggerVatStatusRefreshMutation } from "Api/Mutations/System/useTriggerVatStatusRefreshMutation";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { useCheckPermission } from "Hooks/usePermission";
import { Permission } from "Infrastructure/Api/Api";
import { AccessRightCodes } from "Models/AccessRightCodes";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Admin.VatStatusRefresh;

export const VatStatusRefreshContent = () => {
  const { t } = useResource();
  const canTrigger = useCheckPermission(
    AccessRightCodes.SystemControl,
    Permission.Update,
  );
  const { mutate: triggerRefresh, isPending } =
    useTriggerVatStatusRefreshMutation();

  const handleTrigger = () => {
    triggerRefresh(undefined, {
      onSuccess: () => {
        toast.success(t(RESOURCES.Success));
      },
      onError: () => {
        toast.error(t(RESOURCES.Error));
      },
    });
  };

  return (
    <PrimaryPaper>
      <Stack gap={2} alignItems="flex-start">
        <Typography variant="h6">{t(RESOURCES.Title)}</Typography>
        <Typography>{t(RESOURCES.Description)}</Typography>
        <Button
          variant="contained"
          onClick={handleTrigger}
          disabled={!canTrigger || isPending}
        >
          {isPending ? t(RESOURCES.Loading) : t(RESOURCES.Button)}
        </Button>
      </Stack>
    </PrimaryPaper>
  );
};
